<template>
  <div class="tw-flex tw-gap-3 tw-flex-col sm:tw-flex-row">
    <Dropdown
      v-model="selectedDateOption"
      :options="dateOptions"
      optionValue="value"
      optionLabel="label"
      placeholder="Select Dates"
      scrollHeight="400px"
      class="tw-border tw-border-transparent tw-outline-none tw-shadow dark:tw-bg-slate-800 dark:tw-border-slate-700"
      input-class="tw-p-1 tw-pl-2 tw-text-sm tw-font-medium"
    >
      <template #value="slotProps">
        <div class="tw-flex tw-gap-2 tw-items-center">
          <i class="pi pi-calendar tw-text-sm"></i>
          <span>
            {{
              slotProps.value
                ? dateOptions.find((opt) => opt.value === slotProps.value)
                    ?.label
                : slotProps.placeholder
            }}
          </span>
        </div>
      </template>
    </Dropdown>
    <Calendar
      v-if="selectedDateOption === 'custom'"
      v-model="dates"
      selectionMode="range"
      :manualInput="false"
      class="tw-border tw-border-transparent tw-outline-none tw-shadow tw-rounded-md tw-bg-white dark:tw-bg-slate-800 dark:tw-border-slate-700"
      input-class="tw-p-1 tw-pl-2 tw-text-sm tw-font-medium tw-border-none tw-outline-none tw-bg-none tw-bg-transparent"
    />
  </div>
</template>

<script setup>
import moment from "moment";
import Calendar from "primevue/calendar";
import Dropdown from "primevue/dropdown";
import { ref, watch } from "vue";

const emits = defineEmits(["setDateRange"]);

const dateOptions = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 Days", value: "last7days" },
  { label: "Month-to-Date", value: "monthtodate" },
  { label: "Last 30 Days", value: "last30days" },
  { label: "Custom Dates", value: "custom" },
];

const selectedDateOption = ref("last7days");
const dates = ref([new Date(moment().subtract(1, "week")), new Date(moment())]);

watch(selectedDateOption, (val) => {
  switch (val) {
    case "today":
      dates.value = [new Date(moment()), new Date(moment())];
      break;
    case "yesterday":
      const y = new Date(moment().subtract(1, "day"));
      dates.value = [y, y];
      break;
    case "last7days":
      dates.value = [
        new Date(moment().subtract(1, "week")),
        new Date(moment()),
      ];
      break;
    case "monthtodate":
      dates.value = [new Date(moment().startOf("month")), new Date(moment())];
      break;
    case "last30days":
      dates.value = [
        new Date(moment().subtract(29, "days")),
        new Date(moment()),
      ];
      break;
    case "custom":
      // Keep current selection or let user pick
      break;
  }
});

watch(
  dates,
  (val) => {
    // If dates is null or not an array of two valid dates, reset it
    if (!Array.isArray(val) || val.length !== 2) {
      dates.value = [
        new Date(moment().subtract(6, "days")),
        new Date(moment()),
      ];
    }
    emits("setDateRange", dates.value);
  },
  { immediate: true }
);
</script>
